var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import id from "@irati/utils/id";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import Tooltip, { Tip } from "@irati-web/recognition/src/components/shared/Tooltip";
import { maxLengthString } from "@irati/utils/string";
import CompanyValueTag from "./Tag";
var MAX_TOOLTIP_LIMIT = 10;
var FlexWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: inherit;\n\n  div:last-child {\n    margin-right: 0px;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: inherit;\n\n  div:last-child {\n    margin-right: 0px;\n  }\n"])));
var StyledDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inherit;\n  flex-wrap: inherit;\n  justify-content: inherit;\n"], ["\n  display: inherit;\n  flex-wrap: inherit;\n  justify-content: inherit;\n"])));
var StyledTooltipContent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 1px;\n  text-transform: initial;\n"], ["\n  margin-bottom: 1px;\n  text-transform: initial;\n"])));
var CompanyValues = /** @class */ (function (_super) {
    __extends(CompanyValues, _super);
    function CompanyValues() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTooltip = function () {
            var _a = _this.props, companyValues = _a.companyValues, limit = _a.limit;
            if (companyValues.results.length <= limit) {
                return null;
            }
            var values = companyValues.results.slice(0, MAX_TOOLTIP_LIMIT);
            var total = companyValues.results.length;
            return (React.createElement(Tip, { id: id("company-values-tip", _this.props) },
                values.map(function (c) { return React.createElement(StyledTooltipContent, { key: c.uuid }, maxLengthString({ value: c.tag.toString(), length: 18 })); }),
                (total > MAX_TOOLTIP_LIMIT) &&
                    React.createElement(StyledTooltipContent, null,
                        React.createElement(FormattedMessage, { id: "platform.customerValues.toolTipMore", values: { total: (total - MAX_TOOLTIP_LIMIT) } }))));
        };
        _this.getCustomTags = function () {
            var _a = _this.props, companyValues = _a.companyValues, formatMessage = _a.formatMessage;
            var total = companyValues.results.length;
            return [{
                    archived: false,
                    desc: "",
                    icon: { alt: "", href: "" },
                    name: formatMessage({ id: "platform.customerValues.viewMore" }, { total: total }),
                    tag: formatMessage({ id: "platform.customerValues.viewMore" }, { total: total }),
                    uuid: "platform.customerValues.viewMore"
                }];
        };
        return _this;
    }
    CompanyValues.prototype.render = function () {
        var _a = this.props, companyValues = _a.companyValues, limit = _a.limit;
        if (!companyValues || !companyValues.results || !companyValues.results.length) {
            return null;
        }
        var values = (companyValues.results.length > limit) ? this.getCustomTags() : companyValues.results;
        return (React.createElement(FlexWrapper, null,
            React.createElement(Tooltip, { id: id("company-values-tooltip", this.props), placement: "top", showMobile: false, tip: this.getTooltip() },
                React.createElement(StyledDiv, null, values.map(function (companyValue) { return (React.createElement(CompanyValueTag, { companyValue: companyValue, key: companyValue.uuid })); })))));
    };
    CompanyValues.defaultProps = {
        companyValues: undefined,
        limit: 9999
    };
    return CompanyValues;
}(PureComponent));
export default injectIntl(CompanyValues);
var templateObject_1, templateObject_2, templateObject_3;
